import React, {createContext, useState, useContext, useEffect} from "react";
import {moduleConfig} from './ModulesConfig';
import SessionService from './SessionService';
import {func} from "prop-types";

const AppSessionContext = createContext();

export function useAppSession() {
    return useContext(AppSessionContext);
}

export const AppSessionConsumer = AppSessionContext.Consumer;

export function AppSessionProvider({children}) {
    const [infoPanel, setInfoPanel] = useState({ isOpen : false, type : null });
    const [currentModule, setCurrentModule] = useState("OptimumDesk");
    const [currentModuleConfig, setCurrentModuleConfig] = useState(moduleConfig('OptimumDesk'));
    const [currentCompany, setCurrentCompany] = useState({
        company: null,
        office: null,
        all_companies: false
    });

    // CHANGE MODULE
    useEffect(() => {
        function setConfig() {
            setCurrentModuleConfig(moduleConfig(currentModule))
        }

        setConfig();
    }, [currentModule]);

    // CHANGE COMPANY
    useEffect(() => {

    }, []);

    function toggleInfoPanel()
    {
        setInfoPanel({ ...infoPanel, isOpen: !infoPanel.isOpen });
    }

    function openInfoPanel(options = {})
    {
        setInfoPanel({...options, isOpen: true});
    }

    const value = {
        currentModuleConfig,
        currentModule, setCurrentModule,
        currentCompany, setCurrentCompany,
        toggleInfoPanel, infoPanel, openInfoPanel
    };

    return (
        <AppSessionContext.Provider value={value}>
            {children}
        </AppSessionContext.Provider>
    );
}
